import React from "react";

export default function Template({data}) {
  const { markdownRemark } = data;
  const { frontmatter, html } = markdownRemark;
  const pageClasses = `page__content ${frontmatter.path.slice(1)}`

  return (
    <div>
      <div
        className={ pageClasses }
        dangerouslySetInnerHTML={{ __html: html }}
        data-columns={frontmatter.columns}
      />
    </div>
  );
}

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
        columns
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/template.js